import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { Column, ColumnKeys, GetDataGridItemsResponse } from '../types';
import { Filter } from '../../../grid/gridFilters/types';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';

export class ResponseGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private columns: Array<String> | null = null;
  private filters: Array<Filter<ColumnKeys>>;

  constructor(public dependencies: any) {
    super();
  }

  // This mechanism is used as to fetch only the columns showed in the grid,
  // but this needlessly limits logic in the grid so it is ignored in the backend
  public setColumns(columnIndexes: Array<Column>): void {
    this.columns = columnIndexes.map(colIndex => ColumnKeys[Column[colIndex]]);
  }

  // The grid summary isn't used
  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    return sanitizeObject({
      summary: ``, // Get rid of summary
      numItems: 0,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    const limit = 100;

    const params = {
      incidentId: this.dependencies.incidentId,
      page: request.numRecordsToSkip === undefined ? 0 : request.numRecordsToSkip / limit + 1,
      limit: limit,
      columns: this.columns, // Ignored in the backend, see setColumns
      filters: convertGridFiltersToExtJsFilters(this.filters),
    };

    const response = await this.dependencies.api.clients.GridItemsProvider.readRecords(params);

    // The RawEvents key can not be changed yet even though is it an inappropriate name
    // as it is used in the gz-grid-view controller
    return sanitizeObject({ rawEvents: response.data });
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    this.filters = request.filters;
    return;
  }

  setFiltersSync(request: SetFiltersRequest<ColumnKeys>) {
    this.filters = request.filters;
    return;
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    if (params.columns !== undefined) {
      this.setColumns(params.columns);
    }
    return {};
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
